import type { IconData } from '@stacksjs/iconify-core'

export const table: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 4v8h10V4zm0-4h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export default table
